<template>
  <div class="vrun-form-checkbox-cell-component">
    <div v-if="value">{{ $vt("Yes") }}</div>
    <div v-if="!value">{{ $vt("No") }}</div>
  </div>
</template> 
<script>
export default {
  translate25Context: "vrun_form",
  methods: {},
  props: ["value"],
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.vrun-form-checkbox-cell-component {
  padding: 24px 16px;
}
</style>